// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__mhgio","tab":"ProcedureTabs_tab__1hYK4"};